export default __webpack_public_path__ + "static/media/section-heading-gift.647c2fb6.svg";